import SingleModelInterface from '../../types/singleModelInterface'

export default function filterByDealerCode(
    dealerCode: string,
    cars: SingleModelInterface[]
): SingleModelInterface[] {
    if (dealerCode !== '') {
        return cars.filter((model) => model.in_specialization)
    }

    return cars
}
